import { Wapp } from '@weblite/ts-action/wapp'
import { DBFind, findByIdAsync, insert } from '@weblite/persist'
import { createKeyvalStorage } from '$logic/lib/keyval.storage'

const COLLECTION = 'wapps'

export const wappStorage = {
  getAll(): Promise<Wapp[]> {
    return DBFind(COLLECTION)
  },
  insert(wapps: Wapp[]) {
    insert(COLLECTION)(wapps)
  },
  get(id: string): Promise<Wapp> {
    return findByIdAsync(COLLECTION)(id)
  },
}

export interface WappsConfig {
  alpha: boolean
}

const key = 'wapps'

export const wappsConfigStorage = createKeyvalStorage<WappsConfig>(key)
